//列表类
export class List<T>{
    private listData: Array<T> = [];
    //返回数组
    public toArray(): Array<T> {
        return this.listData;
    }
    //插入数组
    public pushRange(datas: Array<T>) {
        for (var i in datas) {
            this.listData.push(datas[i]);
        }
    }

    //插入一个元素
    public push(data: T) {
        this.listData.push(data);
    }

    //迭代访问所有元素
    public forEach(iterator: Function) {
        for (var i in this.listData) {
            iterator(this.listData[i], i);
        }
    }

    //移除一个元素
    public remove(node: T, comparer: Function = (a: T, b: T) => {
        if (a === b)
            return true;
        else
            return false;
    }) {
        var tmpData: Array<T> = [];
        for (var i in this.listData) {
            if (comparer(this.listData[i], node))
                continue;
            tmpData.push(this.listData[i]);
        }
        this.listData = tmpData;
    }

    //是否包含
    public contains(data, comparer: Function = (data, listNode: T) => {
        if (data === listNode)
            return true;
        else
            return false;
    }) {
        for (var i in this.listData) {
            if (comparer(data, this.listData[i]))
                return true;
        }
        return false;
    }

    //是否包含
    public has(seletor: Function) {
        for (var i in this.listData) {
            if (seletor(this.listData[i]))
                return true;
        }
        return false;
    }

    //更新一个数据
    public update(seletor: Function, setter: Function) {
        for (var i in this.listData) {
            if (seletor(this.listData[i])) {
                setter(this.listData[i]);
            }
        }
    }

    //选择节点
    public select(seletor: Function): List<T> {
        var tmpData: List<T> = new List<T>();
        for (var i in this.listData) {
            if (seletor(this.listData[i]))
                tmpData.push(this.listData[i]);
        }
        return tmpData;
    }

    //长度
    public length(): number {
        return this.listData.length;
    }

    //获取一个元素
    public get(index: number): T {
        return this.listData[index];
    }
}